import React from 'react';
import { Trash2, PanelRightClose } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { ConfirmDialog } from '@shared/patterns';
import { clearActivity } from '@shared/activity';

interface RecentHeaderProps {
  hasItems: boolean;
  onClose?: () => void;
}

export const RecentHeader: React.FC<RecentHeaderProps> = ({ hasItems, onClose }) => {
  return (
    <div className="h-10 px-3 border-b border-border flex items-center justify-between shrink-0">
      <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Recent Activity
      </span>
      <div className="flex items-center gap-1">
        {hasItems && (
          <ConfirmDialog
            trigger={
              <Button
                variant="ghost"
                size="icon"
                className="h-7 w-7 text-muted-foreground hover:text-destructive"
                aria-label="Clear recent history"
              >
                <Trash2 className="h-3.5 w-3.5" />
              </Button>
            }
            title="Clear Recent Activity?"
            description="This will clear your recent pages and action logs on this device."
            confirmLabel="Clear All"
            variant="destructive"
            onConfirm={clearActivity}
          />
        )}
        {onClose && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-7 w-7 text-muted-foreground hover:text-foreground"
            aria-label="Close recent activity panel"
          >
            <PanelRightClose className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
